module.exports = __webpack_public_path__ + "static/img/medal@3x.1d4fc905.png";